import { render, staticRenderFns } from "./companywithdrawal.vue?vue&type=template&id=788e987e&scoped=true&"
import script from "./companywithdrawal.vue?vue&type=script&lang=js&"
export * from "./companywithdrawal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788e987e",
  null
  
)

export default component.exports